import { createModelStore } from '@/shared/stores/create-model-store'
import { model2InitialModel } from './initial-state'
import { model2DimensionHandlers } from './dimensions'

export const useModel2Store = createModelStore({
  initialModel: model2InitialModel,
  dimensionHandlers: model2DimensionHandlers,
})
